import { PayloadAction } from '@reduxjs/toolkit';
import { TPersonalDataApplicationsStore } from '~/store/processing-personal/types.ts';
import { TSignatureValidateDocumentResponse } from '~/store/types.ts';
import { errorMessages } from '~/constants/errorMessages.ts';

export const validateDocumentFulfilled = (
  state: TPersonalDataApplicationsStore,
  action: PayloadAction<TSignatureValidateDocumentResponse>
) => {
  const invalidSignatures = action.payload.documentsWithInvalidSignatures || [];
  const rnokppMismatches = action.payload.documentsWithRNOCPPMismatch || [];
  const noKepDocuments = action.payload.noKepDocuments || [];

  if (noKepDocuments.length > 0) {
    state.loading = false;
    state.error = errorMessages.SERVICE_UNAVAILABLE;
    return;
  }

  if (invalidSignatures.length > 0 || rnokppMismatches.length > 0) {
    state.loading = false;
    state.error = errorMessages.NO_KEP_FILE_FOUND;
    return;
  }

  state.loading = false;
  state.error = null;
};

export const validateDocumentPending = (state: TPersonalDataApplicationsStore) => {
  state.loading = true;
  state.error = null;
};
